"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9963],{

/***/ 7171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M0": function() { return /* binding */ LandingWhiteSec; },
/* harmony export */   "kC": function() { return /* binding */ Flex; },
/* harmony export */   "kj": function() { return /* binding */ LandingGreySecWrap; },
/* harmony export */   "zq": function() { return /* binding */ LandingGreySec; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5505);

var Flex = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "shared-styled-components__Flex",
  componentId: "sc-1i94ptm-0"
})(["display:flex;align-items:center;"]);
var LandingGreySec = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "shared-styled-components__LandingGreySec",
  componentId: "sc-1i94ptm-1"
})(["background:#f5f5f5;padding:", ";margin-top:-120px;margin-bottom:", ";@media only screen and (max-width:768px){padding:", ";margin-top:", ";}"], function (props) {
  return props.padding;
}, function (props) {
  return props.marginBottom;
}, function (props) {
  return props.padding || "16px";
}, function (props) {
  return props.marginTop || "0px";
});
var LandingGreySecWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "shared-styled-components__LandingGreySecWrap",
  componentId: "sc-1i94ptm-2"
})(["width:1200px;margin:0 auto;background:#f5f5f5;@media only screen and (max-width:768px){width:100%;}"]);
var LandingWhiteSec = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "shared-styled-components__LandingWhiteSec",
  componentId: "sc-1i94ptm-3"
})(["width:1200px;margin:0 auto;background:#fff;padding:", ";@media only screen and (max-width:768px){width:100%;padding:16px;}"], function (props) {
  return props.padding;
});

/***/ }),

/***/ 3102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ OnCardTag; }
});

// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/OnCardTag/external.ts
var onCardTagBgMapping = {
  positive: "linear-gradient(88.44deg, #12714F 0.02%, #1CA099 100%)",
  warning: "linear-gradient(88.04deg, #C06D0C 0%, #F2C21A 100%)",
  negative: "linear-gradient(87.77deg, #F5515F -0.75%, #9F0404 100%)",
  generic: "linear-gradient(90deg, #03BAE1 0%, #3A7BD5 100%)",
  offer: "linear-gradient(87.29deg, #C86DD7 0%, #3023AE 100%);",
  neutral: "black"
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/OnCardTag/index.tsx


var OnCardTag = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OnCardTag",
  componentId: "sc-1iwl9fd-0"
})(["padding:4px 8px;border-radius:19px;font-weight:700;font-size:12px;line-height:11px;color:#fff;font-family:\"Open Sans\";text-transform:uppercase;text-align:center;background:", ";"], function (props) {
  return onCardTagBgMapping[props.type || "positive"];
});

/***/ }),

/***/ 9963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ui_container_TestimonialSection; }
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/shared-styled-components/index.ts
var shared_styled_components = __webpack_require__(7171);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8529);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/Image/index.tsx + 1 modules
var Image = __webpack_require__(8863);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/OnCardTag/index.tsx + 1 modules
var OnCardTag = __webpack_require__(3102);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/LandingTestimonials/LandingTestimonials.style.ts


var LandingTestimonialsStyled = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestimonialsStyled",
  componentId: "sc-1nexvs1-0"
})(["display:flex;background:#fff;flex-direction:column;"]);
var LandingTestTitle = styled_components_browser_esm["default"].h3.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestTitle",
  componentId: "sc-1nexvs1-1"
})(["font-family:\"Raleway\";font-weight:500;font-size:56px;line-height:72px;color:#000000;margin-bottom:34px;display:flex;align-items:center;"]);
var LandingTest = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTest",
  componentId: "sc-1nexvs1-2"
})(["display:inline-block;"]);
var LandingTestWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestWrap",
  componentId: "sc-1nexvs1-3"
})(["display:flex;width:575px;padding:32px 30px;background:#fff;position:relative;z-index:1;border-radius:10px;margin-right:20px;& .info{white-space:initial;font-weight:400;font-size:16px;line-height:26px;color:#4a4a4a;}"]);
var LandingTestImg = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestImg",
  componentId: "sc-1nexvs1-4"
})(["width:150px;height:250px;flex-shrink:0;position:relative;margin-right:20px;z-index:1;"]);
var LandingTextCrd = (0,styled_components_browser_esm["default"])(OnCardTag/* OnCardTag */.q).withConfig({
  displayName: "LandingTestimonialsstyle__LandingTextCrd",
  componentId: "sc-1nexvs1-5"
})(["position:absolute;bottom:0;left:50%;transform:translate(-50%,50%);"]);
var PersonName = styled_components_browser_esm["default"].span.withConfig({
  displayName: "LandingTestimonialsstyle__PersonName",
  componentId: "sc-1nexvs1-6"
})(["font-weight:700;font-size:24px;line-height:36px;color:#012136;margin-bottom:2px;display:block;"]);
var LandingTestCntnt = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestCntnt",
  componentId: "sc-1nexvs1-7"
})(["z-index:1;"]);
var Flex = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__Flex",
  componentId: "sc-1nexvs1-8"
})(["display:flex;width:100%;margin-bottom:8px;"]);
var SlideShowContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideShowContainer",
  componentId: "sc-1nexvs1-9"
})(["margin:0 auto;overflow:hidden;max-width:1200px;"]);
var SlideShowSLider = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideShowSLider",
  componentId: "sc-1nexvs1-10"
})(["white-space:nowrap;transition:ease 1000ms;"]);
var SlideDots = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideDots",
  componentId: "sc-1nexvs1-11"
})(["text-align:center;.slideshowDot{background:#3f3d56;opacity:0.2;width:12px;height:12px;border-radius:100%;display:inline-block;margin-right:16px;cursor:pointer;}.slideshowDot.active{width:32px;height:12px;background:#000000 !important;opacity:1;border-radius:6px;}"]);
var StarRating = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__StarRating",
  componentId: "sc-1nexvs1-12"
})(["display:flex;gap:8px;&.starRateFull{position:absolute;top:0;}"]);
var StarRatingWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingTestimonialsstyle__StarRatingWrap",
  componentId: "sc-1nexvs1-13"
})(["margin-bottom:12px;position:relative;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/LandingTestimonials/LandingTestimonials.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var LandingTestimonials = function LandingTestimonials(_ref) {
  var title = _ref.title,
      data = _ref.data,
      starEmpty = _ref.starEmpty,
      starFull = _ref.starFull;

  var _React$useState = react.useState(0),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      index = _React$useState2[0],
      setIndex = _React$useState2[1];

  var timeoutRef = react.useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  react.useEffect(function () {
    resetTimeout();
    timeoutRef.current = setTimeout(function () {
      return setIndex(function (prevIndex) {
        return prevIndex === data.length - 1 ? 0 : prevIndex + 1;
      });
    }, 250000);
    return function () {
      resetTimeout();
    };
  }, [index]);
  var testimonialCategoryTagThemeMapping = {
    lending: "positive",
    forex: "generic",
    insurance: "offer"
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestimonialsStyled, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingTestTitle, {
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SlideShowContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SlideShowSLider, {
        className: "slideshowSlider",
        style: {
          transform: "translate3d(".concat(-index * 595, "px, 0, 0)")
        },
        children: data && data.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTest, {
            className: "slide",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestWrap, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestImg, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, {
                  src: item.personImg,
                  width: "150",
                  height: "250"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTextCrd, {
                  type: testimonialCategoryTagThemeMapping[item.personCrdClass],
                  children: item.personCard
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestCntnt, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PersonName, {
                    children: item.personName
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StarRatingWrap, {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StarRating, {
                      children: Array.from({
                        length: 5
                      }, function (_, index) {
                        return /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread(_objectSpread({}, starEmpty), {}, {
                          className: "starRate"
                        }), index);
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StarRating, {
                      className: "starRateFull",
                      children: Array.from({
                        length: item.personRating
                      }, function (_, index) {
                        return /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({}, starFull), index);
                      })
                    })]
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "info",
                  children: item.testInfo
                })]
              })]
            })
          }, index);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SlideDots, {
        className: "slideshowDots",
        children: data.map(function (_, idx) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "slideshowDot".concat(index === idx ? " active" : ""),
            onClick: function onClick() {
              setIndex(idx);
            }
          }, idx);
        })
      })]
    })]
  });
};

/* harmony default export */ var LandingTestimonials_LandingTestimonials = (LandingTestimonials);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/TestimonialSection/index.tsx




var TestimonialSection = function TestimonialSection(_ref) {
  var title = _ref.title,
      data = _ref.data,
      starEmpty = _ref.starEmpty,
      starFull = _ref.starFull;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(shared_styled_components/* LandingWhiteSec */.M0, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTestimonials_LandingTestimonials, {
      title: title,
      data: data,
      starEmpty: starEmpty,
      starFull: starFull
    })
  });
};

/* harmony default export */ var ui_container_TestimonialSection = (TestimonialSection);

/***/ })

}]);